import styled, { css } from 'styled-components/macro';
import { colorBlackTransparent50, colorCoreBlack300, colorCoreBlack900Base, colorCoreGray500, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { getTextStyles } from '@yme/utils/styles';
const leftLabel = css `
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-left: 1px solid;
  border-right: none;

  border-radius: ${CORNER_RADIUS.s} ${CORNER_RADIUS.none} ${CORNER_RADIUS.none} ${CORNER_RADIUS.s};
`;
const rightLabel = css `
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-right: 1px solid;
  border-left: none;

  border-radius: ${CORNER_RADIUS.none} ${CORNER_RADIUS.s} ${CORNER_RADIUS.s} ${CORNER_RADIUS.none};
`;
export const LabelStyled = styled.label `
  ${getTextStyles('Ubuntu', 500, 14, 20)};

  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 12px 0;

  ${({ isRightToLeft }) => (isRightToLeft ? rightLabel : leftLabel)}

  user-select: none;
  width: 50%;

  border-color: ${colorCoreGray500};
  color: ${colorCoreBlack300};

  &:last-child {
    ${({ isRightToLeft }) => (isRightToLeft ? leftLabel : rightLabel)}
  }
`;
export const SwitcherItemStyled = styled.input `
  display: none;

  &:checked + label {
    border: 1px solid ${colorCoreBlack900Base};
    background: ${colorBlackTransparent50};
    color: ${colorCoreBlack900Base};
  }
`;
export const SwitcherStyled = styled.div `
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'};
`;
